import { withCloseAfterExited } from "../modal";
import {
  AssignAdminModalProps,
  default as View
} from "./assign-admin-modal-view";

const AssignAdminModal = withCloseAfterExited<AssignAdminModalProps>(View);
export default AssignAdminModal;
